import { Module } from 'vuex';
import IRootState from '@/store/types/IRootState';
import IAboutState from './types/IAboutState';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const about: Module<IAboutState, IRootState> = {
  namespaced: true,
  state: {
    meta: {
      title: '',
      description: '',
    },
    header: {
      title: '',
      description: '',
      image: '',
    },
    sections: [],
  },
  actions,
  getters,
  mutations,
};

export default about;
